import type { CharacterAsset } from './types';
import { assertCharacterAsset } from './render-plan';

export async function loadCharacterAsset(
  url: string,
  expectedHash: string,
  signal?: AbortSignal,
): Promise<CharacterAsset> {
  const response = await fetch(url, { credentials: 'omit', signal });
  if (!response.ok) throw new Error(`failed to fetch character asset: ${response.status}`);
  const bytes = await response.arrayBuffer();
  await verifySha256(bytes, expectedHash);
  const asset: unknown = JSON.parse(new TextDecoder().decode(bytes));
  assertCharacterAsset(asset);
  return asset;
}

async function verifySha256(bytes: ArrayBuffer, expected: string): Promise<void> {
  if (!/^sha256:[0-9a-f]{64}$/i.test(expected)) {
    throw new Error('invalid character asset hash');
  }
  const subtle = globalThis.crypto?.subtle;
  if (!subtle) {
    throw new Error('character asset SHA-256 verification is unavailable');
  }
  const digest = await subtle.digest('SHA-256', bytes);
  const actual = [...new Uint8Array(digest)].map((value) => value.toString(16).padStart(2, '0')).join('');
  if (`sha256:${actual}` !== expected.toLowerCase()) {
    throw new Error('character asset hash mismatch');
  }
}
